
import { onMounted, ref} from 'vue'

export default {
    name: "HeroFrontPage",
    setup(){

        const executeVisibilityTransition = ref(false)
        
        onMounted(() => {
 
            executeVisibilityTransition.value = true
       
        })

        return {
            executeVisibilityTransition
        }
    }
}